<!-- 个人中心 -->
<template>
  <div class="page" v-cloak>
    <van-nav-bar :border="false" left-arrow right-text="编辑" fixed title="个人中心" class="user_nav_bar" @click-left="onClickLeft" @click-right="onClickRight" :z-index="20" :style="'background: #4374FF; color:#FFFFFF;'"></van-nav-bar>

    <div class="header-block">
      <!-- 用户头像 -->
      <div class="header-info-block" @click="goPageAA({ name: 'user-service', query: {} })">
        <div class="user-img">
          <img v-if="userInfo.head_photo" :src="userInfo.head_photo" alt="" />
          <img v-else :src="missingFace" alt="" />
        </div>
        <div class="user-name">
          <p class="name">{{userInfo.user_nickname || '默认用户'}}</p>
          <!-- <p class="tips">请登录</p> -->
        </div>
      </div>

      <!-- 用户数据 -->
      <div class="header-data-block">
        <div class="header-data">
          <div class="header-data-item line">
            <p class="title">余额(元)</p>
            <p class="num">{{balance.total | numToCash}}</p>
          </div>
          <div class="header-data-item">
            <p class="title">累计消费(元)</p>
            <p class="num">{{balance.cunsume_amt | numToCash}}</p>
          </div>
        </div>
      </div>

    </div>

    <!-- 1 -->
    <div class="center-block">
      <div class="top-block" v-for="(item,index) in routerList" :key="index" @click="goPage(item)">
        <div class="top-icon">
          <img :src="item.icon" alt="">
          <span>{{item.title}}</span>
        </div>
        <div class="right-icon">
          <van-icon name="arrow" />
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/babel">
export default {
  name: "user",
  components: {},
  props: {},
  data() {
    return {
      missingFace: require("../../assets/mine/missing-face.png"),
      mobile: "",

      userInfo: {},
      balance: {
        cunsume_amt: 0,
        gift_amt: 0,
        total: 0,
        true_amt: 0,
      },
      defaultRouterList: [
        {
          icon: require("../../assets/mine/order_icon_2.png"),
          title: "我的账户",
          router: "user-balance",
        }, 
        {
          icon: require("../../assets/mine/order_icon_5.png"),
          title: "零钱抢购",
          router: "",
        },
        {
          icon: require("../../assets/mine/order_icon_5.png"),
          title: "百分百生活馆",
          router: "",
        },
        {
          icon: require("../../assets/mine/order_icon_4.png"),
          title: "人工洗车",
          router: "",
        },
        {
          icon: require("../../assets/mine/order_icon_3.png"),
          title: "设置",
          router: "user-service",
        },
      ],

      routerList: [],
      //  // 我的商户-》商户后台
      // 员工登录-》设备安装
      // 后台管理-》后台
      repairList: [
        {
          icon: require("../../assets/mine/set-up.png"),
          title: "员工登录",
          router: "repair-manage",
          // ,
        },
      ],
      merchantList: [
        {
          icon: require("../../assets/mine/set-up.png"),
          title: "我的商户",
          router: "merchant-manage",
        },
      ],
      manageList: [
        {
          icon: require("../../assets/mine/set-up.png"),
          title: "后台管理",
          router: "staff-manage",
          // ,
        },
      ],

      aa: {},
    };
  },
  watch: {
    aa: {
      handler(newValue, oldValue) {
        // console.log(newValue, oldValue);
      },
      deep: true, // 深度监听表单
    },
  },
  created() {},
  mounted() {
    //
    //  是否登陆过
    // if (this.isLogin()) {
    if (!this.isLogin()) return false;
    this.getInit(); //获取用户信息
    this.getRefreshUid();
    //   this.getCollection();
    // }
    this.userInfo = Lockr.get("userInfo"); //用户信息
  },
  methods: {
    // 初始化数据
    getInit() {
      let _this = this;
      this.$toast.loading();
      _this.$post("/api/user_info").then((res) => {
        // console.log(res.data, "底部table");
        _this.$toast.clear();
        if (res.data && res.data.code == 0) {
          this.userInfo = res.data.data.user;
          this.balance = res.data.data.balance;
        }
      });
    },
    getRefreshUid() {
      let _this = this;
      // isRepair 1=维修人员  isMerchant  1=商户    isManage  1=管理员

      _this
        .$post(
          "/api/refreshUid",
          { openid: Lockr.get("openId") },
          { openid: Lockr.get("openId") }
        )
        .then((res) => {
          // console.log(res.data.data, "refreshUid");
          if (res.data && res.data.code == 0) {
            Lockr.set("user_type", res.data.data.user_type); //用户类型
            _this.routerList = [];
            let dataList = JSON.parse(JSON.stringify(_this.defaultRouterList));
            if (
              res.data.data.user_type &&
              res.data.data.user_type.isRepair == 1
            ) {
              dataList = dataList.concat(_this.repairList);
            } 
            if (
              res.data.data.user_type &&
              res.data.data.user_type.isMerchant == 1
            ) {
              dataList = dataList.concat(_this.merchantList);
            } 
            if (
              res.data.data.user_type &&
              res.data.data.user_type.isManage == 1
            ) {
              dataList = dataList.concat(_this.manageList);
            }
            _this.routerList = dataList;
          } else {
            _this.routerList = _this.defaultRouterList;
          }
        });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    // 编辑
    onClickRight() {
      this.$router.push({ name: "user-service", query: {} });
      // this.$toast("敬请期待！");
    },

    goPage(even) {
      let _this = this;
      if (!this.isLogin()) return false;

      // console.log(even)
      if (!even.router) {
        _this.$toast.fail("敬请期待！");
        // 无跳转
        return;
      } else {
        this.$router.push({ name: even.router, query: {} });
      }
    },

    goOrder(item) {
      if (!this.isLogin()) return false;
      this.$router.push({
        name: item.router,
        query: {
          tab: item.tab,
        },
      });
    },
    onService(ite, ind) {
      if (!this.isLogin()) return false;
      if (ind == 5) {
        this.MakeCall(); //拨打电话
      } else if (ite.router) {
        this.$router.push({
          name: ite.router,
          query: {},
        });
      } else {
        this.$toast("敬请期待！");
      }
    },
    goPageAA(url) {
      if (!this.isLogin()) return false;
      // debugger
      this.$router.push(url);
    },
    // 获取用户积分
    getPoints() {
      let _this = this;
      _this.$get("/points/api/Points").then((res) => {
        // console.log(res.data);
        this.points = res.data.data || 0;
      });
    },
    // 获取收藏数
    getCollection() {
      let _this = this;
      _this
        .$get("/product/api/Wish", {
          Page: 1,
          Size: 1000,
        })
        .then((res) => {
          // console.log(res.data.data.total);
          this.collection = res.data.data.total || 0;
        });
    },
  },
};
</script>
<style lang="scss">
.user_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.page {
  // height: 100%;
  width: 100%;
  padding-bottom: 50px;
  background-color: #ffffff;
}

.center-block {
  // height: 54px;
  background: #ffffff;

  .top-block {
    height: 54px;
    //   background-color: green;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;

    .top-icon {
      width: 140px;
      height: 100%;

      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        display: inline-block;
        width: 20px;
        height: 20px;
      }
      span {
        margin-left: 16px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }

    .right-icon {
      width: 20px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #333333;
    }
  }
  .foot-block {
    padding: 0 15px 15px;
    //   background-color: fuchsia;
    border-radius: 10px;
    transition: 3s;
    text-align: left;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
}

.header-block {
  height: 300px;
  width: 100%;
  padding-top: 45px;

  position: relative;

  // 用户头像
  .header-info-block {
    height: 190px;
    width: 100%;
    // background-color: #eee;
    background: linear-gradient(0deg, #2fa4ff 0%, #4374ff 99%);

    background-color: #fff;
    padding: 0 15px 0 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .user-img {
      width: 65px;
      height: 65px;
      border-radius: 50%;
      box-shadow: 0px 5px 5px rgba(69, 79, 99, 0.08);
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .user-name {
      text-align: left;
      margin-left: 10px;
      .name {
        margin-top: 15px;

        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
      .tips {
        margin-top: 15px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  // 用户数据
  .header-data-block {
    height: 85px;
    width: 100%;
    // background-color: rgba(69, 225, 225, 0.4);
    position: absolute;
    bottom: 15px;
    left: 0;

    .header-data {
      height: 100%;
      width: 315px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background-color: #fff;
      border-radius: 10px;
    }
    .header-data-item {
      width: 125px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      .num {
        margin-top: 10px;

        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        letter-spacing: 1px;
      }
      .title {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        letter-spacing: 1px;
      }
    }
    .line::after {
      content: "";
      position: absolute;
      width: 1px;
      height: 30px;
      right: -14%;
      top: 30%;
      //   background: red;
      background: #e7e7e7;
      z-index: 1;
    }
  }
}
</style>
